var exports = {
  "x": "ExpiryFootnote.module__footnote___TnVzdE",
  "m": "ExpiryFootnote.module__inlineFootnote___TnVzdE",
};

module.exports = exports;
